import React, { useEffect, useState } from 'react';
import styles from './Header.module.css';

import frenchFlag  from '../../images/flags/flag-for-flag-france.svg'
import englishFlag from '../../images/flags/flag-for-flag-united-kingdom.svg'

import song from '../../songs/song.mp3'

import paths from '../../config/paths';
import { NavLink } from 'react-router-dom';

export default function Header(props) {
    const { handleHome, 
            handleSkills, 
            handleProjects, 
            handleContact, 
            isMenuOpen, 
            handleMenu} = props;

    const [isVolumeOn, setIsVolumeOn] = useState(false);  
    const [isFlagOpen, setIsFlagOpen] = useState(false);  
    const [isProjectOpen, setIsProjectOpen] = useState(false);

    function handleClickSound() {
        const song = document.querySelector('#song');
        if (isVolumeOn) {
            song.volume = 0;
            song.pause();            
        } else {
            song.currentTime = 0;
            song.volume = 0.02;
            song.play();
        }
        setIsVolumeOn(prevIsVolumeOn => !prevIsVolumeOn);
    }

    function handleClickFlag() {
        setIsFlagOpen(prevIsFlagOpen => !prevIsFlagOpen);
    }

    const openProjects = () => {
        setIsProjectOpen(true)
    }
    const closeProjects = () => {
        setIsProjectOpen(false)
    }
    const changeProjects = () => {
        setIsProjectOpen(!isProjectOpen)
    }


    useEffect(() =>{
        const projects = document.querySelector('#projects-menu');
        if (isProjectOpen) {
            projects.style.display = "block";
            setTimeout(() => {
                projects.style.opacity = "1";
            }, 50);
        } else {
            projects.style.opacity = "0";
            setTimeout(() => {
                projects.style.display = "none";
            }, 300);
        }
    }, [isProjectOpen])
    return (
        <header className={styles.header}>
            <div hidden className='hidden'><audio src={song} id="song" loop ></audio></div>
            <div className={isMenuOpen ? `${styles.navContainer} ${styles.navContainerOpen}` : `${styles.navContainer} ${styles.navContainerClose}`}>
                <nav className={styles.navbar}>
                    <ul className={styles.navbarList}>
                        <NavLink className={styles.link} to={paths.HOME} onClick={handleHome}>Accueil</NavLink>
                        <NavLink className={styles.link} to={paths.SKILLS} onClick={handleSkills}>Compétences</NavLink>
                        <div className={styles.projectsContainer} onMouseEnter={openProjects} onMouseLeave={closeProjects}>
                            <div className={styles.projectText}>
                                <NavLink className={styles.link} to={paths.PROJECTS} onClick={handleProjects}>Projets</NavLink>
                                <i className={isProjectOpen ? "fa-solid fa-caret-up ml-2" : "fa-solid fa-caret-down ml-2"} onClick={changeProjects}></i>
                            </div>
                            <div className={`hidden ${styles.projects}`} id="projects-menu">
                                <ul>
                                    <li><NavLink className={styles.link} to={paths.QUAI_ANTIQUE}>Quai Antique</NavLink></li>
                                    <li><NavLink className={styles.link} to={paths.CHARLES_CANTIN}>Charles Cantin</NavLink></li>
                                    <li><NavLink className={styles.link} to={paths.DES_AVENTURES}>Dés Aventures</NavLink></li>
                                    <li><NavLink className={styles.link} to={paths.ROLLIN_BATTLE}>Rollin' Battle</NavLink></li>
                                    <li><NavLink className={styles.link} to={paths.MEMORY}>Memory</NavLink></li>
                                    <li><NavLink className={styles.link} to={paths.MLP}>My Little Pony</NavLink></li>
                                    <li><NavLink className={styles.link} to={paths.CODEPEN}>Codepen</NavLink></li>
                                </ul>
                            </div>
                        </div>
                        <NavLink className={`${styles.link} ${styles.contactButton}`} to={paths.CONTACT} onClick={handleContact}>Contactez moi !</NavLink>
                        <a className={`${styles.link} ${styles.CVButton}`} href={paths.CV} target="_blank">Mon CV</a>
                        <li className={`${styles.link} navbar-icon`} aria-label="Linkedin"><a href="https://www.linkedin.com/in/erika-andre-do-brito/" target="_blank"><i className="fa-brands fa-linkedin"></i></a></li>
                        <li className={`${styles.link} navbar-icon`} aria-label="Github"><a href="https://github.com/Coussecousse" target="_blank"><i className="fa-brands fa-github"></i></a></li>
                    </ul>
                </nav>
                <ul className={styles.optionsList}>
                    <li className={`${styles.volumeButton} ${styles.link}`} onClick={handleClickSound} aria-label="Musique">
                        <button>
                            <i className={isVolumeOn ? 'fa-solid fa-volume-high' : 'fa-solid fa-volume-xmark'}></i>
                        </button>
                    </li>
                    <li className={styles.flagsList}>
                        <ul>
                            <li className={`flag-container ${styles.flagContainer} ${styles.link}`}>
                                <button className={styles.flagButton}>
                                    <img className="flag" src={frenchFlag} alt="Drapeau français" />
                                    <p>FR</p>
                                </button>
                                <button onClick={handleClickFlag}><i className={isFlagOpen ? "fa-solid fa-caret-up" : "fa-solid fa-caret-down"}></i></button>
                            </li>
                            <li className={`flag-container ${styles.flagContainer} ${styles.link}`} style={{ 'position' : 'absolute', 'width': '100%', 'display' : isFlagOpen ? 'block' : 'none'}}>
                                <a href="https://erika-s-portfolio-eng.netlify.app/" className={styles.flagButton} aria-label="Site anglais">
                                    <img className="flag" src={englishFlag} alt="Drapeau anglais" />
                                    <p>EN</p>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className={styles.mobileButtonContainer}><button className={ isMenuOpen ? styles.openMobileButton : styles.closeMobileButton} onClick={handleMenu}></button></div>
        </header>
    )
}